<button [ngClass]="classCustom" (click)="onClick($event)">
  {{title}}
</button>
